'use client'

/** The approved public header is shared with the homepage. Internal tooling imports its preserved renderer directly. */
export { PublicSiteHeader as SiteHeader } from './chrome/public-site-chrome'
